import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-preview",
  "use": "icon-preview-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-preview\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16.33,15.49,18,17.16l-.84.84-1.67-1.67ZM11.32,6A5.32,5.32,0,1,1,6,11.32,5.32,5.32,0,0,1,11.32,6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol